import React from 'react'
import LandingPage from '../../components/excelAnalytics/LandingPage'
const ExcelAnalytics = () => {
  return (
    <div>
      <>
        <LandingPage />
      </>
      <></>
    </div>
  )
}
export default ExcelAnalytics
